import { render } from "./FlashCardPart.vue?vue&type=template&id=e682a44a"
import script from "./FlashCardPart.vue?vue&type=script&lang=js"
export * from "./FlashCardPart.vue?vue&type=script&lang=js"

import "./FlashCardPart.vue?vue&type=style&index=0&id=e682a44a&lang=css"

import exportComponent from "C:\\Users\\aarhondakis\\Desktop\\lernapp_quellcode\\lernapp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__